module.exports = "<div [ngClass]=\"icon\" *ngIf=\"icon\"></div>\n<div class=\"th__content\" *ngIf=\"title\"><span class=\"th__content__title\" appTitle>{{ title }}</span></div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/tables/form-table/form-column/form-column.component.html
// module id = ../../../../../src/app/shared/components/tables/form-table/form-column/form-column.component.html
// module chunks = main